// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  releaseId: __t.u64().primaryKey().name("release_id"),
  provider: __t.string(),
  modelId: __t.string().name("model_id"),
  displayName: __t.string().name("display_name"),
  contextWindow: __t.u32().name("context_window"),
  priceInputMicrosPerMtok: __t.i64().name("price_input_micros_per_mtok"),
  priceOutputMicrosPerMtok: __t.i64().name("price_output_micros_per_mtok"),
  capabilityFlagsJson: __t.string().name("capability_flags_json"),
  seenAt: __t.i64().name("seen_at"),
  queuedForShadow: __t.bool().name("queued_for_shadow"),
});
